import { API_BASE_URL } from '../api';
import { Questionnaire, QuestionnaireSubmission, QuestionnaireValidation } from '../types/questionnaire';

export const questionnaireService = {
  // Récupérer le questionnaire pour un service par ID (RECOMMANDÉ)
  async getForServiceId(serviceId: number): Promise<Questionnaire | null> {
    const url = `${API_BASE_URL}/api/questionnaires/for-service-id/${serviceId}`;
    
    const response = await fetch(url);
    
    if (response.status === 404) {
      return null;
    }
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Erreur lors de la récupération du questionnaire');
    }
    
    const data = await response.json();
    
    if (data.questionnaire_required && data.questionnaire) {
      return data.questionnaire;
    }
    
    return null;
  },

  // Récupérer le questionnaire pour un service par nom (DEPRECATED)
  async getForService(serviceName: string): Promise<Questionnaire | null> {
    const url = `${API_BASE_URL}/api/questionnaires/for-service/${encodeURIComponent(serviceName)}`;
    
    const response = await fetch(url);
    
    if (response.status === 404) {
      return null;
    }
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Erreur lors de la récupération du questionnaire');
    }
    
    const data = await response.json();
    
    if (data.questionnaire_required && data.questionnaire) {
      return data.questionnaire;
    }
    
    return null;
  },

  // Soumettre les réponses au questionnaire
  async submit(submission: QuestionnaireSubmission): Promise<QuestionnaireValidation> {
    // S'assurer que les réponses sont bien des booléens
    const cleanedSubmission = {
      ...submission,
      responses: Object.keys(submission.responses).reduce((acc, key) => {
        const value = submission.responses[key];
        acc[key] = typeof value === 'string' ? value === 'true' : Boolean(value);
        return acc;
      }, {} as Record<string, boolean>)
    };
    
    // Questionnaire submission
    
    const response = await fetch(`${API_BASE_URL}/api/questionnaires/submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cleanedSubmission),
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Erreur lors de la soumission du questionnaire');
    }
    
    return response.json();
  },

  // Valider l'éligibilité pour une réservation
  async validateBooking(bookingId: number): Promise<QuestionnaireValidation> {
    const response = await fetch(`${API_BASE_URL}/api/questionnaires/validate-booking/${bookingId}`);
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Erreur lors de la validation');
    }
    
    return response.json();
  },
};
